import { formatPhoneNumberIntl } from "react-phone-number-input";
import { Typography } from "@/components/atoms";
import { FavouritePassenger } from "@/redux/apis/favouritePassenger/types";
import { GuestPassengerRowMenu } from "./components/GuestPassengerRowMenu";
import { GuestPassengersSortKey, GuestPassengersTableData } from "./types";

/** Client-side sort — we fetch all guests at once (mobile parity), so the server doesn't sort. */
export const sortGuestPassengers = (
  guests: FavouritePassenger[],
  key: GuestPassengersSortKey | undefined,
  desc: boolean
): FavouritePassenger[] => {
  if (!key) return guests;
  return [...guests].sort((a, b) => {
    const cmp = (a[key] ?? "").toString().localeCompare((b[key] ?? "").toString(), undefined, { sensitivity: "base" });
    return desc ? -cmp : cmp;
  });
};

/** Spaced international display (e.g. +61 400 123 456); non-E.164 values fall back to the raw string. */
export const formatContactNumber = (phone: string): string => formatPhoneNumberIntl(phone) || phone;

export const generateGuestPassengersData = (guests: FavouritePassenger[], accountId?: string): GuestPassengersTableData[] =>
  guests.map((guest) => ({
    firstName: <Typography>{guest.first_name}</Typography>,
    lastName: <Typography>{guest.last_name}</Typography>,
    contactNumber: <Typography className="whitespace-nowrap">{formatContactNumber(guest.phone)}</Typography>,
    emailAddress: (
      <Typography className="block max-w-[500px] truncate" title={guest.email}>
        {guest.email}
      </Typography>
    ),
    action: <GuestPassengerRowMenu guest={guest} accountId={accountId} />,
  }));
